<div class="fortaris-botao-voltar-wrapper" [attr.data-has-permission]="permissao ? true : null">
  <button
    *ngIf="!permissao"
    pButton
    type="button"
    icon="pi pi-arrow-left"
    [label]="texto"
    class="fortaris-botao-voltar"
    [attr.aria-label]="ariaLabel"
    (click)="voltar()"
  ></button>

  <button
    *appTemPermissao="permissao!"
    pButton
    type="button"
    icon="pi pi-arrow-left"
    [label]="texto"
    class="fortaris-botao-voltar"
    [attr.aria-label]="ariaLabel"
    (click)="voltar()"
  ></button>
</div>
